/**
 * @typedef {Object} CompanyTag
 * @property {number} [id]
 * @property {string} name
 * @property {string} [color]
 */

/**
 * @param {unknown} tags
 * @returns {CompanyTag[]}
 */
export function normalizeTags(tags) {
  if (!Array.isArray(tags)) return [];
  return tags
    .map((tag) => {
      if (typeof tag === 'object' && tag?.name) {
        return {
          id: tag.id != null ? Number(tag.id) : null,
          name: String(tag.name),
          color: tag.color || null,
        };
      }
      if (typeof tag === 'string' && tag.trim()) {
        return { id: null, name: tag.trim(), color: null };
      }
      return null;
    })
    .filter(Boolean);
}
